'use strict';
var AirportSelectorView = require('od-modules/views/airport_selector.view');
var DateSelectorView = require('od-modules/views/date_selector.view');
var trackingUtils = require('od-modules/utils/tracking.utils.js');
var FocusHandler = require('./focus_handler');

module.exports = Odigeo.View.extend({

    selectors: {
        origin: '#origin_field_container',
        destination: '#destination_field_container',
        departureDate: '#depart_date_field_container',
    },

    trackingMap: {
        '#origin_field_container': 'orig',
        '#destination_field_container': 'dest',
        '#depart_date_field_container': 'dep',
    },

    dateFocusControllerMap: {
        '#depart_date_field_container': 'returnDateView',
    },

    events: {
        'click .oneline_md_remove_item': 'removeItem',
    },

    initialize: function(options) {
        this.options = Odigeo._.extend({}, options, this.optionsFromTemplate());

        this.template = this.options.templates.main;
        this.render();
        this.departureAirportView = this.createAirportSelectorView('DEPARTURE');
        this.destinationAirportView = this.createAirportSelectorView('ARRIVAL');
        this.departureDateView = this.createDateSelectorView();
        this.setErrorMapping();
        this.setSearchSegmentViewValues();

        this.listenTo(this.model, 'sync:fetch', this.setSearchSegmentViewValues);
        this.listenTo(this.model, 'update', this.updateSearchSegments);
        this.listenTo(this.model, 'change', this.setSearchSegmentViewValues);
        this.listenTo(this.model, 'error', this.onErrorHandler);

        this.childrenView = [
            this.departureAirportView,
            this.destinationAirportView,
            this.departureDateView,
        ];
        this.bindChildrenEvents();
        this.childrenFocusHandler = new FocusHandler(this.childrenView);
    },

    bindChildrenEvents: function() {
        Odigeo._.forEach(this.childrenView, Odigeo._.bind(function(view) {
            view.on('fulfilled', Odigeo._.bind(this.onChildFulfilled, this));
        }, this));
    },

    optionsFromTemplate: function() {
        var $options = $('#multiple_destination_item_options');
        if ($options && $options.length) {
            return JSON.parse($options.html());
        }
        return {};
    },

    removeItem: function() {
        Odigeo.trigger('OneLinerMultiDestination:remove', this.options.index);
    },

    setErrorMapping: function() {
        this.errorsMap = {
            'date': {obj: 'departureDateView', showError: 'triggerError'},
            'departure': {obj: 'departureAirportView', showError: 'showError'},
            'destination': {obj: 'destinationAirportView', showError: 'showError'},
        };
    },

    createAirportSelectorView: function(type) {
        var selector = type === 'DEPARTURE' ? 'origin' : 'destination';
        var callbacks = {
            onFocus: Odigeo._.bind(this.focusHandler, this),
        };

        return new AirportSelectorView({
            el: this.$el.find(this.selectors[selector] + this.options.index),
            template: this.options.templates.airport,
            templateAutoComplete: this.options.templates.autoComplete,
            templateAutoCompleteZero: this.options.templates.autoCompleteZero,
            departureOrArrival: type,
            placeholder: this.options.placeholders[selector],
            tabIndex: {
                'origin': 0,
                'destination': 1,
            }[selector],
            errorMessages: this.options.errorMessages,
            callbacks: callbacks,
            parent: this,
            showNearestLocations: this.options.showNearestLocations,
        });
    },

    createDateSelectorView: function() {
        var index = this.options.index;
        var callbacks = {
            onFocus: Odigeo._.bind(this.focusHandler, this),
        };

        return new DateSelectorView({
            el: this.$el.find(this.selectors.departureDate + index),
            template: this.options.templates.date,
            format: this.options.dateFormat,
            index: index,
            tabIndex: index + 2,
            calendarDaysNames: this.options.calendarDaysName,
            callbacks: callbacks,
            parent: this,
            placeholder: this.options.placeholders.departureDate,
            closeButton: this.options.closeButton,
            type: 'multiple',
            isCssVariationHeaderDesktop: Odigeo.AB.isCssVariationHeaderDesktop,
            errorMessages: Odigeo.AB.isCssVariationHeaderDesktop ? this.options.errorMessages : null,
            datepickerClasses: {
                inputClass: Odigeo.AB.isCssVariationHeaderDesktop ?
                    'od-ui-datepicker-field wl-bookingcom-input cobalt-variation od-ui-datepicker-field-cobalt-last-field'
                    : 'od-ui-datepicker-field wl-bookingcom-input',
                containerClass: 'od-ui-datepicker-container datepicker od-input-right',
            },
        });
    },

    onErrorHandler: function(errors) {
        errors = Odigeo._.filter(errors, Odigeo._.bind(function(error) {
            return error.index === this.options.index;
        }, this));

        this.removeErrors();
        if (!Odigeo._.isEmpty(errors)) {
            Odigeo._.each(errors, Odigeo._.bind(this.handleError, this));
        }
    },

    removeErrors: function() {
        this.departureAirportView.removeError();
        this.destinationAirportView.removeError();
        this.departureDateView.removeError();
    },

    handleError: function(error) {
        var errorOpts = !Odigeo._.isUndefined(this.errorsMap[error.key]) ? this.errorsMap[error.key] : null;
        if (!Odigeo._.isNull(errorOpts) && this.model.get('searchSubmit') === true) {
            this[errorOpts.obj][errorOpts.showError](error.type);
        }
    },

    focusHandler: function(element) {
        var selector = '#' + element.$el.attr('id');

        this.model.setSearchModelProperty('focused', selector);
        this.model.setSearchModelProperty('editsearch', true);
        trackingUtils.trackEvent('searcher_flights', 'open_change_search_' + this.trackingMap[selector]);
    },

    setSearchSegmentViewValues: function() {
        var segment = this.model.toJSON();

        this.departureAirportView.model.set('selectedLocation', segment.departure);
        this.destinationAirportView.model.set('selectedLocation', segment.destination);
        this.departureDateView.model.set('selectedDate', segment.dateStr ? Odigeo.Utils.parseDate(segment.dateStr) : null);
    },

    updateSearchSegments: function() {
        var date = this.departureDateView.model.get('selectedDate');

        var segment = {
            departure: this.departureAirportView.model.get('selectedLocation'),
            destination: this.destinationAirportView.model.get('selectedLocation'),
            dateStr: date ? Odigeo.Utils.formatDate(date, Odigeo.Utils.formatDate.masks.isoDate) : null,
        };

        this.model.save(segment);
    },

    render: function() {
        this.$el.html(this.template({
            index: this.options.index,
            hideDeleteButton: this.options.hideDeleteButton,
        }));

        return this;
    },

    onChildFulfilled: function() {
        this.trigger('fulfilled');
    },

    isEmptyOrHasError: function() {
        return this.childrenFocusHandler.isEmptyOrHasError();
    },

    setFocus: function() {
        this.childrenFocusHandler.setFocus();
    },
});
